import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GenesisUnitOfWork, AppInformationService } from '../../core/core.module';
import _ from 'lodash';
import { confirm, alert } from 'devextreme/ui/dialog';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-invoice-order-dialog',
    templateUrl: './invoice-order-dialog.component.html',
    styleUrls: ['./invoice-order-dialog.component.scss'],
    standalone: false
})
export class InvoiceOrderDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    invoiceNumbers: any;
    orders: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;


    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        this.orders = await this.uow.getOrdersByInvoiceNumbers(this.invoiceNumbers);
    }

    async select() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData() as any;
        if (selectedRow.length === 0) return;
        this.result.next({ success: true, value: selectedRow[0].id });
    }

    close() {
        this.result.next(false);
    }
}
